import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { dealsAPI } from "../api";
import { toast } from "react-toastify";
import { useT } from "../../../i18n";

// Get all deals across every partner (admin view)
export const useGetAllDeals = () => {
  return useQuery({
    queryKey: ["admin-deals"],
    queryFn: dealsAPI.getAllDeals,
    retry: 2,
    staleTime: 5 * 60 * 1000,
  });
};

// Extend a deal's reservation by N months
export const useExtendReservation = () => {
  const t = useT();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ uuid, months }: { uuid: string; months: number }) =>
      dealsAPI.extendReservation(uuid, months),
    onSuccess: (data: any) => {
      toast.success(t("deals.toast.extended"));
      queryClient.invalidateQueries({ queryKey: ["admin-deals"] });
    },
    onError: (error: any) => {
      toast.error(
        t("deals.toast.extendFailed")
      );
    },
  });
};
